import React from "react";
import './Body11.css';
import {Link} from "react-router-dom"
import picture241 from './source/picture241.png'
import picture231 from './source/picture231.png'
import picture232 from './source/picture232.png'
import picture233 from './source/picture233.png'
import picture234 from './source/picture234.png'
import picture235 from './source/picture235.png'
import picture236 from './source/picture236.png'
import picture237 from './source/picture237.png'
import picture238 from './source/picture238.png'
import picture239 from './source/picture239.png'
import picture240 from './source/picture240.png'


function Body11() {

  return (
    <div className="body11">
      <div className="body11-box1">
        <div className="body11-box2">
          <div className="body11-box3">Hluk</div>
          <div className="body11-box5"><div className="body11-box4"></div></div>
          <div className="body11-box6">
          <img className="body11-box6-picture2" src={picture231} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture232} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture233} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture235} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture236} alt="picture1"/>
          <img className="body11-box6-picture" src={picture241} alt="picture1"/>
          <img className="body11-box6-picture" src={picture234} alt="picture1"/>
          <img className="body11-box6-picture" src={picture237} alt="picture1"/>
          <img className="body11-box6-picture" src={picture238} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture239} alt="picture1"/>
          <img className="body11-box6-picture2" src={picture240} alt="picture1"/>
          </div>
          <div className="body11-box8"><div className="body11-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body11;
